import React from 'react';

import { StyledAccordion } from './AccordionToggle.styles';

import { AccordionToggleProps } from './AccordionToggle.types';

const AccordionToggle = ({
  isExpanded,
  componentClassname,
  ...props
}: AccordionToggleProps) => {
  return (
    <StyledAccordion
      className={`${componentClassname} ${componentClassname}--${
        isExpanded ? 'expanded' : 'closed'
      }`}
      {...props}
    />
  );
};

AccordionToggle.displayName = 'AccordionToggle';

export default AccordionToggle;
